import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { AUTHED_MEMBER } from '../../../apollo';
import { memberSlice } from '../../../redux';

type AuthedMemberEffectReturn = {
  authedMember: () => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useAuthedMemberEffect = (
  callback?: (data?: any) => void
): AuthedMemberEffectReturn => {
  const dispatch = useDispatch();

  const [success, setSuccess] = useState(false);

  const [doAuthedMember, authedMemberState] = useLazyQuery(AUTHED_MEMBER, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      dispatch(memberSlice.actions.authed(data.authedMember));
      setSuccess(true);
      console.log({ data });

      if (callback) {
        callback(data);
      }
    },
  });

  const { loading, error } = authedMemberState;

  const authedMember = (): void => {
    doAuthedMember();
  };

  return { authedMember, loading, success, error: error?.message };
};
